/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Type_Gaz_FioulInputs */



/**
* | output |
* | --- |
* | "Gas / oil boiler" |
*
* @param {Boiler_Type_Gaz_FioulInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_type_gaz_fioul = /** @type {((inputs?: Boiler_Type_Gaz_FioulInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Type_Gaz_FioulInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Gas / oil boiler")
	return /** @type {LocalizedString} */ ("Chaudière gaz / fioul")
});